import React from 'react';

import styled, { css } from 'styled-components';

interface IGridList {
  template?: string;
}

const List = styled.div<IGridList>`
  display: grid;
  width: 100%;
  justify-content: center;

  ${props =>
    (props.template === 'search' || props.template === 'collection') &&
    css`
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 12px;
      row-gap: 12px;

      ${props => props.theme.breakpoints.up('sm')} {
        column-gap: 24px;
        row-gap: 24px;
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      ${props => props.theme.breakpoints.up('lg')} {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }
    `}

  ${props =>
    props.template === 'categories' &&
    css`
      grid-template-columns: 48% 48%;
      row-gap: 12px;
      column-gap: 12px;
      padding: 0 12px 12px;
      margin-top: 16px;

      ${props => props.theme.breakpoints.up('sm')} {
        column-gap: 0px;
        row-gap: 8px;
        padding: 0px 8px;
        grid-template-columns: 30% 30% 30%;
      }

      ${props => props.theme.breakpoints.up('lg')} {
        row-gap: 8px;
        padding: 8px;
      }
    `}

	${props =>
    props.template === 'artisans_with_products' &&
    css`
      grid-template-columns: repeat(1, 1fr);
      row-gap: 32px;
      column-gap: 16px;
      padding-top: 0px;
      padding-bottom: 40px;
      ${props => props.theme.breakpoints.up('sm')} {
        grid-template-columns: repeat(2, 1fr);
        column-gap: 24px;
      }
      ${props => props.theme.breakpoints.up('md')} {
        grid-template-columns: repeat(3, 1fr);
        /* padding-left: 24px; */
        padding-right: 0px;
      }
      ${props => props.theme.breakpoints.up('lg')} {
        grid-template-columns: repeat(4, 1fr);
      }
    `}

    ${props =>
    props.template === 'onbording_gender' &&
    css`
      grid-template-columns: repeat(2, 1fr);
      row-gap: 32px;
      column-gap: 16px;
      padding-top: 0px;
      ${props => props.theme.breakpoints.up('sm')} {
        grid-template-columns: repeat(2, 1fr);
        column-gap: 24px;
      }
      ${props => props.theme.breakpoints.up('md')} {
        grid-template-columns: repeat(3, 1fr);
        padding-right: 0px;
      }
      ${props => props.theme.breakpoints.up('lg')} {
        grid-template-columns: repeat(3, 1fr);
      }
    `}
    ${props =>
    props.template === 'onbording_categories' &&
    css`
      grid-template-columns: repeat(2, 1fr);
      row-gap: 24px;
      column-gap: 16px;
      padding-top: 0px;
      padding-right: 16px;
      ${props => props.theme.breakpoints.up('sm')} {
        grid-template-columns: repeat(3, 1fr);
        column-gap: 24px;
      }
      ${props => props.theme.breakpoints.up('md')} {
        grid-template-columns: repeat(4, 1fr);
      }
      ${props => props.theme.breakpoints.up('lg')} {
        grid-template-columns: repeat(4, 1fr);
      }
    `}
`;

const GridList: React.FC<IGridList> = props => {
  return (
    <>
      <List template={props.template}> {props.children} </List>
    </>
  );
};

export default GridList;
